import React from 'react';
import { HelperText, HelperTextProps } from '../../Form/HelperText';
import { UdsFC } from '../../../types';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormHelperText: UdsFC<HelperTextProps> = ({ children, className, ...props }) => {
  const context = useAppFormControlContext();
  const isError = 'error' in props ? props.error : !!context.error;
  const isDisabled = 'disabled' in props ? props.disabled : !!context.disabled;
  const dataTestFactory = appFormDataTestFactory(props.dataTest ?? context.dataTest);
  const errorMessage = 'error' in props ? children : context.error;

  if (!children && !isError) {
    return null;
  }
  return (
    <HelperText
      className={className}
      error={isError}
      disabled={isDisabled}
      dataTest={isError ? dataTestFactory.formHelperError : dataTestFactory.formHelper}
    >
      {isError ? errorMessage : children}
    </HelperText>
  );
};
